import React, {useEffect} from 'react';

import {CompetitionsSliderWidgetDropdownItem} from "./competitions-slider-widget.dropdown.item";
import {ACTION_TYPES, WIDGET_TYPES} from "../../../../core/consts";
import {ENTITY_TYPES} from "../../../../core/app/consts";
import {COMPETITIONS_SLIDER_WIDGET} from "../../competition-slider-widget.consts";
import {CompetitionViewModel} from "../../../../domain/common/competition/models/competition-view-model";
import {Dropdown} from "../../../../core/components/dropdown/dropdown";
import {CompetitionsSliderWidgetProps} from "../../models/competitions-slider-widget.props";

export class CompetitionsSliderWidgetDropdownProps extends CompetitionsSliderWidgetProps {
  selectedCompetitionId: Number;
}

export const CompetitionsSliderWidgetDropdown = ({controller, selectedCompetitionId}: CompetitionsSliderWidgetDropdownProps) => {
 const {state, device} = controller;
  useEffect(() => {
    controller.action(ACTION_TYPES.sliderEntityDisplay, {
      entityId: state.selectedCompetitionId,
      entityType: ENTITY_TYPES.competition,
      competitionId: state.selectedCompetitionId,
      sportTypeId: state.appState.context.sportType?.id,
      widgetType: WIDGET_TYPES.slider,
      partner: state.appSettings.publisherSettings.id,
      screenResolution: device.screenWidth
    });
  }, [selectedCompetitionId]);

  const dropdownProps = {
    items: controller.state.competitions,
    selectedValue: state.selectedCompetitionId,
    ListItem: CompetitionsSliderWidgetDropdownItem,
    listClassName: 'competitions-slider-widget-dropdown-list',
    listItemProps: {
      device,
      listLength: state.competitions.length,
    },
    containerClassName: 'competitions-slider-widget-dropdown-container',
    arrowDownClassName: ['competitions-slider-widget-dropdown-arrow','competitions-slider-widget-dropdown-down-arrow'].join(' '),
    arrowUpClassName: ['competitions-slider-widget-dropdown-arrow','competitions-slider-widget-dropdown-up-arrow'].join(' '),


    onChange: (selectedCompetition: CompetitionViewModel) => {
      controller.action(COMPETITIONS_SLIDER_WIDGET.ACTION_TYPES.competitionChange, {id: selectedCompetition.id});
      onEntityClickEvent(selectedCompetition);
    },
  }

  const dropdownContainerProps = {
    className: 'competitions-slider-widget-dropdown',
    onClick: () => onMenuClickEvent()
  }

  const onMenuClickEvent = () => controller.action(ACTION_TYPES.menuClick, {
    competitionId: state.selectedCompetitionId,
    sportTypeId: state.appState.context.sportType?.id,
    widgetType: WIDGET_TYPES.slider,
    partner: state.appSettings.publisherSettings.id,
    screenResolution: device.screenWidth
  });

  const onEntityClickEvent = (selectedCompetition: CompetitionViewModel) => controller.action(ACTION_TYPES.entityClick, {
    competitionId: selectedCompetition.id,
    entityId: selectedCompetition.id,
    sportTypeId: selectedCompetition.sport.id,
    widgetType: WIDGET_TYPES.slider,
    partner: state.appSettings.publisherSettings.id,
    screenResolution: device.screenWidth
  });

  return (
    <div {...dropdownContainerProps}>
      <Dropdown {...dropdownProps}/>
    </div>
  )
}
